<template>
    <div class="page account-area">
        <div class="page-content">
            <div class="dz-height">

            </div>
            <div class="fixed-content container">
                <div class="tabs">
                    <div class="tab tab-active form-elements tabs">
                        <form class="tab tab-active" novalidate="" v-on:submit.prevent="submit">
                            <div class="title-head">

                                <center>
                                    <img src="static/images/logo3.png" style="width: 200px; margin-top: 30px; margin-bottom: 20px;">
                                </center>

                                <h2 class="title" style="text-align: center;">
                                    <i class="las la-user-circle"></i>
                                    Entrar
                                </h2>
                                <p style="text-align: center;">Acesse sua conta da Agenda Master.</p>
                            </div>
                            <div class="list">
                                <ul class="row">
                                    <li class="item-content item-input col-100">
                                        <div class="item-inner">
                                            <div class="item-title item-label">E-mail</div>
                                            <div class="item-input-wrap">
                                                <input type="email" placeholder="Escreva seu e-mail" v-model="form.email" value="" class="form-control"/>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="item-content col-100 item-input">
                                        <div class="item-inner">
                                            <div class="item-title item-label">Senha</div>
                                            <div class="item-input-wrap">
                                                <input type="password" v-model="form.senha" placeholder="Escreva sua senha" class="form-control"/>
                                               
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="clearfix">
                                <button type="submit" class="button-large button button-fill">
                                    <i class="las la-check-circle"></i>
                                    Entrar
                                </button>
                                <p class="form-text"><a class="tab-link" v-on:click="recuperarSenha">Esqueceu sua senha?</a></p>
                            </div>
                            <div class="text-align-center account-footer">
                                <p class="mt-0">Ainda não possui cadastro?</p>
                                <router-link :to="{'name': 'Cadastro'}" class="link external button-large button button-fill button-gray">CADASTRE-SE</router-link>
                            </div>
                        </form>
                        
                    </div>
                </div>
            </div>
        </div>
        
    </div>      
</template>

<script>
export default {
    name: 'Login',
    data () {
        return {
            loading: {
                "recuperarSenha":   false,
                "submit":           false,
            },
            form: {
                "email":            "",
                "senha":            ""
            }
        }
    },
    methods: {
        demonstracao: function(email) {
            console.log("demonstracao()", email);
            var self = this;
            if (email == "close") {
                $(".demonstracao").fadeOut();
                $(".page-login").removeClass("demonstracao-open");                
                return false;                
            }
            if (!email) {
                $("input").blur();
                $(".demonstracao").fadeIn(1000);
                $(".page-login").addClass("demonstracao-open");
            } else {
                $(".demonstracao").fadeOut();
                $(".page-login").removeClass("demonstracao-open");                
                self.form.email = email;
                self.form.senha = "123123123";
                self.submit();
            }
        },
        recuperarSenha: function(e) {
            var self            = this;
            console.log("recuperarSenha", e, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.recuperarSenha = true;
            loading.show();
            axios.post("api/recuperar-senha.php", self.form)
            .then(response => {
                loading.hide();
                self.loading.recuperarSenha = false;
                console.log("ok", response)
                alert(response.data.message);
            })
            .catch(error => {
                loading.hide();
                self.loading.recuperarSenha = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        submit: function(e) {
            var self            = this;
            var form            = JSON.parse(JSON.stringify(self.form));
            loading.show();
            if (e) e.preventDefault();
            self.loading.submit = true;
            form.senha          = md5(form.senha);

            axios.post("api/login.php", form)
            .then(response => {

                console.log(">>>", response.data)
                // self.loading.submit = false;
                if (response.data.user) {
                    if (response.data.user.tipo != "admin" && response.data.user.tipo != "prestador") {
                        alert("Esse acesso é destinado somente para profissionais e administradores do sistema.");
                        return false;
                    }

                    self.$root.setUser(response.data.user).then(function() {
                        // self.$router.push({"name": "Dashboard"});
                        setTimeout(function() {
                            location.reload();
                        }, 200);
                    });
                } else {
                    loading.hide();
                }
                // alert(response.data.message);
            })
            .catch(error => {
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        }        
    },
    mounted: function() {
        setTimeout(function() {
            loading.hide();
        }, 500);
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
   
</style>



// WEBPACK FOOTER //
// src/components/Login.vue